import { render, staticRenderFns } from "./TemplateView.vue?vue&type=template&id=51b13788&scoped=true"
import script from "./TemplateView.vue?vue&type=script&lang=js"
export * from "./TemplateView.vue?vue&type=script&lang=js"
import style0 from "./TemplateView.vue?vue&type=style&index=0&id=51b13788&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b13788",
  null
  
)

export default component.exports